import React from 'react';
import PropTypes from 'prop-types';

const DownloadIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '16px';
  const h = (height) ? height.toString().concat('px') : '16px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 16 16"
      width={w}
      height={h}
    >
      <path
                // eslint-disable-next-line max-len
        d="M7.29323 11.1435C7.523 11.3305 7.85248 11.3305 8.08224 11.1435L10.777 8.95044C11.0447 8.73256 11.0851 8.3389 10.8672 8.07118C10.6493 7.80346 10.2557 7.76305 9.98797 7.98093L8.31274 9.34427L8.31274 1.98926C8.31274 1.64408 8.03292 1.36426 7.68774 1.36426C7.34256 1.36426 7.06274 1.64408 7.06274 1.98926L7.06274 9.34427L5.38751 7.98093C5.11979 7.76305 4.72613 7.80346 4.50825 8.07118C4.29037 8.3389 4.33077 8.73256 4.5985 8.95044L7.29323 11.1435ZM1.625 13.3857C1.27982 13.3857 1 13.6655 1 14.0107C1 14.3559 1.27982 14.6357 1.625 14.6357H14.125C14.4702 14.6357 14.75 14.3559 14.75 14.0107C14.75 13.6655 14.4702 13.3857 14.125 13.3857H1.625Z"
        fill={(fill) || 'black'}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

DownloadIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default DownloadIcon;
